<template>
  <div v-if="product">
    <b-container fluid class="p-0 mt-4">
      <b-row>
        <b-col cols="12" :md="bigPicture ? 4 : 3" class="mb-5">
          <div class="product-name mb-2 d-block d-sm-none">{{ product.default_description }}</div>
          <slot name="pictures">
            <PictureFallback :picture="product.picture" class="product-picture" />
          </slot>
        </b-col>

        <b-col cols="12" md="5" class="mb-5 product-summary">
          <ProductSummary :product="product" />
          <slot name="product-info"></slot>
        </b-col>

        <b-col cols="12" md="" v-if="price">
          <slot name="price">
            <div class="best-price">
              {{ $t("product_sheet_base.best_price") }}
            </div>
            <div>
              <span class="price-before pr-2">
                {{ $formatMoney(priceBefore, currency) }}
              </span>
              <span class="price ml-3">
                {{ $formatMoney(price, currency) }}
              </span>
            </div>
          </slot>

          <b-form class="order my-3 pt-3">
            <label
              id="quantity-group"
              for="quantity"
              class="quantity"
            >
              {{ $t("product_sheet_base.quantity") }}
            </label>
            <b-container fluid class="p-0 m-0">
              <vue-element-loading :active="to_cart_loading" />
              <b-row align-v="center">
                <b-col :cols="bigPicture ? 5 : 4">
                  <NumericInput
                    id="quantity"
                    v-model="quantity"
                    :min="1"
                    align="center"
                    size="100%"
                  />
                </b-col>
                <b-col :cols="bigPicture ? 12 : 8">
                  <b-button
                    class="py-2 w-100"
                    v-bind:class="{ 'mt-3': bigPicture }"
                    variant="cart"
                    @click="buyProduct(quantity)"
                  >{{ $t('product_sheet_base.add') }}</b-button>
                  <b-button
                    class="py-2 w-100"
                    v-bind:class="{ 'mt-3': bigPicture }"
                    variant="buy"
                    @click="buyProduct(quantity, true)"
                  >{{ $t('product_sheet_base.buy') }}</b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-form>

          <slot name="purchase-info"></slot>
        </b-col>
        <b-col cols="12" md="3" v-else>
          <div class="mb-3 pb-2">
            <b-alert
              variant="warning"
              show
            >{{ $t("product_sheet_base.error.can_buy_only_if_has_logged") }}</b-alert>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import { ProductCardMixin } from "@/mixins/ProductCardMixin";
import PictureFallback from "@/components/PictureFallback";
import ProductSummary from "@/components/ProductSummary";
import NumericInput from "@/components/NumericInput";

export default {
  name: "product-sheet-base",
  components: {
    PictureFallback,
    ProductSummary,
    NumericInput,
  },
  mixins: [ProductCardMixin],
  props: {
    product: Object,
    bigPicture: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quantity: Number(1),
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        product_sheet_base: {
          add: "Add to the cart",
          buy: "Buy this product",
          best_price: "Best price",
          error: {
            can_buy_only_if_has_logged:
              "You can only buy this product if you are logged in",
          },
          quantity: "Quantity",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.product-summary {
  border-right: 1px solid $border-color;
}

.product-name {
  color: $text-third-color;
  font-size: $font-size-medium * 1.5;
}

.price {
  color: $corp-color2;
  font-size: $font-size-medium * 2;
  font-weight: bold;
}

.order {
  border-top: 1px solid $border-color;
}

.quantity {
  font-weight: bold;
  width: 6rem;
}

.product-picture {
  border: 1px solid $border-color;
}

.best-price {
  color: $corp-color1;
  font-weight: bold;
}

.price-before {
  border-right: 1px solid;
  font-size: $font-size-medium * 1.1;
  text-decoration: line-through;
}
</style>
